import { Component, OnInit, Injector } from '@angular/core';
import { SecondPageEditBase, UserService } from 'vnpost-shared';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { passwordPattern } from '../../../config/password.config';
import { ConfirmationService } from 'primeng/api';
import { UserTypeId } from '../../../config/enums';
import { UnitService } from '../../../core/services/unit-service';
import { CoreUserService } from '../../../core/services/core-user.service';
import { SaleAssociateService } from '../../services/sale-associate.service';

@Component({
  selector: 'app-add-sale-associate',
  templateUrl: './add-sale-associate.component.html',
  styleUrls: ['./add-sale-associate.component.css']
})
export class AddSaleAssociateComponent extends SecondPageEditBase implements OnInit {
  listUnit: { label: string; value: string }[] = [];
  listGender: { label: string; value: number }[] = [{label: "Nam", value: 1}, {label: "Nữ", value: 0}];
  listStatus: { label: string; value: number }[] = [{label: "Đang hoạt động", value: 1}, {label: "Dừng hoạt động", value: 0}];
  unitCode = this.currentUser?.unitCode;
  listEthnic: { label: string; value: string }[] = [
    { label: 'Kinh', value: '1' },
    { label: 'Khác', value: '2' },
  ];

  constructor(
    protected _userService: UserService,
    protected _injector: Injector,
    private _unitService: UnitService,
    private _saleAssociateService: SaleAssociateService,
  ) {
    super(_userService, _injector);
    this.formGroup = new UntypedFormGroup({
      salesAssociateCode: new UntypedFormControl([Validators.required]),
      email: new UntypedFormControl('', [Validators.email]),
      displayName: new UntypedFormControl('', [Validators.required]),
      location: new UntypedFormControl(''),
      gender: new UntypedFormControl('', [Validators.required]),
      userName: new UntypedFormControl([Validators.required]),
      dateOfBirth: new UntypedFormControl('', [Validators.required]),
      phoneNumber: new UntypedFormControl('', [Validators.required, Validators.pattern(/^0\d{8,11}$/)]),
      citizenId: new UntypedFormControl('', [Validators.pattern(/^\d{9,12}$/)]),
      socialInsuranceCode: new UntypedFormControl(''),
      address: new UntypedFormControl(''),
      unitCode: new UntypedFormControl('', [Validators.required]),
      notes: new UntypedFormControl(''),
      status: new UntypedFormControl(''),
    });
  }

  ngOnInit() {
  }

  getListUnit() {
    this._unitService.getTreeUnitByUnitCode(this.currentUser?.unitCode).then((rs) => {
      if (rs.success) {
        this.listUnit = rs?.data
          ?.map((r) => ({
            label: `- ${r.unitName} (${r.unitCode})`,
            value: r.unitCode,
          }));
      } else {
        this.listUnit = [];
      }
    });
  }

  onShowPopup() {
    this.validationSummary.resetErrorMessages();
    this.resetForm();
    if (this.listUnit.length == 0) {
      this.getListUnit();
    }
    this.onReset();

    let associateArrStorage = localStorage.getItem('associateArr');
    if (associateArrStorage) {
      let associateArr = JSON.parse(associateArrStorage) ?? [];
      let associateObj = associateArr.find(x => x?.unitCode === this.unitCode);
      if (associateObj) {
        this.itemDetail.salesAssociateCode = associateObj?.salesAssociateCode;
      }
      else {
        this._saleAssociateService.generateSalesAssociateCode(this.unitCode).then(res => {
          this.itemDetail.salesAssociateCode = res.data;
          let newAssociateObj = {
            unitCode: this.unitCode,
            salesAssociateCode: res.data
          }
          associateArr.push(newAssociateObj);
          localStorage.setItem('associateArr', JSON.stringify(associateArr));
        }, error => {
          if (error?.error?.message) 
            this._notifierService.showError(error?.error?.message);
          else this._notifierService.showError('Khởi tạo mã CTV thất bại');
        });
      }
    }
    else {
      this._saleAssociateService.generateSalesAssociateCode(this.unitCode).then(res => {
        this.itemDetail.salesAssociateCode = res.data;
        var associateArr = [{
          unitCode: this.unitCode,
          salesAssociateCode: res.data
        }]
        localStorage.setItem('associateArr', JSON.stringify(associateArr));
      }, error => {
        if (error?.error?.message) 
          this._notifierService.showError(error?.error?.message);
        else this._notifierService.showError('Khởi tạo mã CTV thất bại');
      });
    }

    this.itemDetail.id = 0;
    this.itemDetail.gender = 1;
    this.itemDetail.unitCode = this.currentUser.unitCode;
    this.itemDetail.status = 1;
  }

  onChangeUnitCode() {
    let associateArrStorage = localStorage.getItem('associateArr');
    if (associateArrStorage) {
      let associateArr = JSON.parse(associateArrStorage) ?? [];
      let associateObj = associateArr.find(x => x?.unitCode === this.itemDetail.unitCode);
      if (associateObj) {
        this.itemDetail.salesAssociateCode = associateObj?.salesAssociateCode;
      }
      else {
        this._saleAssociateService.generateSalesAssociateCode(this.itemDetail.unitCode).then(res => {
          this.itemDetail.salesAssociateCode = res.data;
          let newAssociateObj = {
            unitCode: this.itemDetail.unitCode,
            salesAssociateCode: res.data
          }
          associateArr.push(newAssociateObj);
          localStorage.setItem('associateArr', JSON.stringify(associateArr));
        }, error => {
          if (error?.error?.message) 
            this._notifierService.showError(error?.error?.message);
          else this._notifierService.showError('Khởi tạo mã CTV thất bại');
        });
      }
    }
    else {
      this._saleAssociateService.generateSalesAssociateCode(this.itemDetail.unitCode).then(res => {
        this.itemDetail.salesAssociateCode = res.data;
        var associateArr = [{
          unitCode: this.itemDetail.unitCode,
          salesAssociateCode: res.data
        }]
        localStorage.setItem('associateArr', JSON.stringify(associateArr));
      }, error => {
        if (error?.error?.message) 
          this._notifierService.showError(error?.error?.message);
        else this._notifierService.showError('Khởi tạo mã CTV thất bại');
      });
    }
  }

  async save() {
    this.submitting = true;

    if (this.formGroup.invalid) {
      this.submitting = false;
      this.validationSummary.showValidationSummary();
      return;
    }
    this.onInsert();
  }

  onInsert() {
    this._saleAssociateService.create(this.itemDetail).then(
      (response) => {
        let associateArrStorage = localStorage.getItem('associateArr');
        if (associateArrStorage) {
          let associateArr = JSON.parse(associateArrStorage) ?? [];
          associateArr = associateArr.filter(x => x.unitCode !== this.itemDetail.unitCode);
          localStorage.setItem('associateArr', JSON.stringify(associateArr));
        }
        this.closePopupMethod(true);
        this._notifierService.showInsertDataSuccess();
        this.onAfterSave();
        this.submitting = false;
      },
      (error) => {
        if (error?.error?.message) 
          this._notifierService.showError(error?.error?.message);
        else this._notifierService.showInsertDataFailed();
        this.submitting = false;
      }
    );
  }
}
